import { render, staticRenderFns } from "./MonitObservePage.vue?vue&type=template&id=f279ee7a&"
import script from "./MonitObservePage.vue?vue&type=script&lang=js&"
export * from "./MonitObservePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports